<template>
    <div class="comment-container">
        <div class="h-fit comment-content white-rounded-box mb-5 mr-4">
            <div class="">
                <div class="flex items-top mb-1">
                    <UserNameRef
                        :showingDefaultAvatar="showingDefaultAvatar"
                        :user="comment.user"
                    />
                    <div class="flex my-1 text-hint">
                        <a v-if="comment.user.type === 'pro'"
                            :href="comment.user.storefront_url"
                            class="no-underline"
                            >{{ comment.user.display_name }}</a
                        >
                        <span v-else class="no-underline">
                            {{ comment.user.display_name }}
                        </span>
                        <span class="italic ml-2 text-md">{{
                            moment(comment.created_at).fromNow()
                        }}</span>
                    </div>
                </div>
            </div>
            <component
                :is="renderedContent"
                v-on:tagClicked="tagClicked"
                class="linebreak"
            ></component>
            <div v-if="comment.documents">
                <ul v-for="document in comment.documents">
                    <a
                        :href="document.pivot.full_uri"
                        target="_blank"
                        class="text-salesium-blue"
                        >{{ document.name }}</a
                    >
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import UserNameRef from "./UserNameRef.vue";
import FilePreview from "./FilePreview";
export default {
    data() {
        return {
            showingDefaultAvatar: true,
        };
    },
    props: {
        comment: {
            type: Object,
            required: true,
        },
    },
    methods: {
        tagClicked(tag) {
            this.$emit("tagClicked", tag);
        },
    },
    computed: {
        renderedContent() {
            const userRegex = RegExp(
                /\B@{([a-z0-9_-]+)}{([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})}/gi
            );

            let contentWithMentions = this.comment.content.replaceAll(
                userRegex,
                (match, username, id) => {
                    // const user = this.post.mentions.find(mention => mention.id === id);
                    // if (user) {
                    // if (user.type == "pro"){
                    // return `<a href="${user.storefront_url}" class="no-underline">@${user.display_name}</a>`;
                    // }else{
                    // return `<a class="no-underline">@${user.display_name}</a>`;
                    // }
                    // } else {
                    return `@${username}`;
                    // }
                }
            );

            const tagRegex = RegExp(/\B#([a-z0-9_]+)/gi);

            let contentWithTags = contentWithMentions.replaceAll(
                tagRegex,
                (match) => {
                    return `<a @click="()=>{this.$emit('tagClicked', '${match}')}" class="no-underline inline-flex items-center px-3 py-2 rounded-full font-medium leading-4 bg-gray-200 text-gray-800">${match}</a>`;
                }
            );

            return {
                template: "<div>" + contentWithTags + "</div>",
            };
        },
    },
    components: {
        UserNameRef,
    },
};
</script>
<style scoped>
.comment-container {
    /*margin-left: 10%;*/
    border-left: 3px solid grey;
}
.comment-content {
    padding: 3%;
    margin-left: 10%;
}
.linebreak {
    white-space: pre-wrap;
}
</style>
